import { render, staticRenderFns } from "./BadgeCustom.vue?vue&type=template&id=020df2ae"
import script from "./BadgeCustom.vue?vue&type=script&lang=js"
export * from "./BadgeCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports